import React from 'react';
import {
    useTheme, 
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,    
    Stack,
    Divider,
} from '@mui/material';
import {
    Close, 
    PersonPin,
    Phone,
    TravelExplore,
} from '@mui/icons-material';
import { formatTZDate } from "state/helpers";
import FlexBetween from 'components/FlexBetween'; 


const InfoRow = ({ label, value }) => (
    <FlexBetween gap={1}>
        <Typography ml={0.5} fontWeight={500}>{label}</Typography>
        <Typography>{value || ''}</Typography>
    </FlexBetween>
);

const formatDate = (date) =>
    date ? formatTZDate(new Date(date), 'UTC', 'dd MMM yyyy') : '';

const CrewMemberDialog = ({ open, onClose, crewMember }) => {
    const theme = useTheme();

    if (!crewMember) return null;

    const {
        crewCode,
        crewName,
        gender,
        rank,
        location,
        quals,
        contactTel,
        email,
        birthday,
        passportName,
        passportNumber,
        passportIssueDate,
        passportExpiryDate,
        passportCountry,
    } = crewMember;

    const sections = [
        {
            title: "Position",
            icon: <PersonPin color="primary" fontSize="small" />,
            data: [            
                { label: "Rank", value: rank },
                { label: "Base", value: location },
                { label: "Quals", value: quals },
            ],
        },
        {
            title: "Contact",
            icon: <Phone color="primary" fontSize="small" />,
            data: [
                { label: "Phone", value: contactTel },
                { label: "Email", value: email },
            ],
        },
        {
            title: "Passport",
            icon: <TravelExplore color="primary" fontSize="small" />,
            data: [
                { label: "Full Name", value: passportName },
                { label: "Gender", value: gender },
                { label: "Birthday", value: formatDate(birthday) },
                { label: "Passport Number", value: passportNumber },
                { label: "Issue Date", value: formatDate(passportIssueDate) },
                { label: "Expiry Date", value: formatDate(passportExpiryDate) },
                { label: "Place of Issue", value: passportCountry },
            ],
        },
    ];      


    return (
        <Dialog 
            fullWidth
            maxWidth="sm" 
            open={open} 
            onClose={onClose} 
        >
            <DialogTitle borderBottom={`1px solid ${theme.palette.neutral.dark}`}>
                <Typography fontWeight="bold" color="primary.dark">
                    {crewCode} - {crewName}
                </Typography>
                <IconButton
                    onClick={onClose}                    
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.neutral.dark,
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {sections.map((section, idx) => (
                    <React.Fragment key={idx}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
                            {section.icon}
                            <Typography color="primary.dark">
                                {section.title}
                            </Typography>
                        </Stack>

                        <Stack spacing={0.5}>
                            {section.data.map(({ label, value }) => (
                                <InfoRow key={label} label={label} value={value} />
                            ))}
                        </Stack>
                        {idx < sections.length - 1 && <Divider sx={{ my: 1 }} />}
                    </React.Fragment>
                ))}
            </DialogContent>

            <DialogActions>
                <Button 
                    variant="outlined" 
                    color="primary" 
                    onClick={onClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CrewMemberDialog;
